import { render } from "./comp-form-small.vue?vue&type=template&id=8b6cc964&ts=true"
import script from "./comp-form-small.vue?vue&type=script&lang=ts"
export * from "./comp-form-small.vue?vue&type=script&lang=ts"

import "./comp-form-small.vue?vue&type=style&index=0&id=8b6cc964&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__